export const TERMS_REQUIRED_EVENT_KEY = 'arcade:terms-required'
